var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shopView"},[_c('pane-header',{attrs:{"text":_vm.data.name}}),_c('item-grid',{attrs:{"images":_vm.game.map.images,"items":_vm.data.inventory,"slots":200,"screen":"shop"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }